// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1VCKf","logo":"Header_logo__3_SJs","nav":"Header_nav__3yRlw","delegateBtn":"Header_delegateBtn__oNQmj"};